<custom-table [config]="customTable"[rowExpansionTemplate]="tableRowexpansion">
</custom-table>

<ng-template #tableRowexpansion let-data>
    <app-seguimientos-historial [actividadId]="data.id"
                                class="app-card mx-auto border-1 border-top-none border-noround-top"/>
</ng-template>

<section>
	<form [formGroup]="reasignarForm" (ngSubmit)="onSubmitReasignarForm()">
		<p-dialog [header]="'msg.reasignarUsuario' | translate" [(visible)]="displayReasignarModal" [modal]="true"
			[breakpoints]="{'960px': '100vw'}" [style]="{width: '60vw'}" [draggable]="false" [resizable]="true"
			[maximizable]="true">
			<div class="grid">
				<div class="field col-12 flex flex-column">
					<label for="usuarioId">{{"common.usuarioAsignado" | translate}}<span style="color: red">*</span></label>
					<p-dropdown [options]="usuariosValidos" appendTo="body" placeholder="Usuario..." optionLabel="nombre" optionValue="id"					
					[disabled]="!ls.hasRole(role.GESTION_TRAMITE)" formControlName="usuarioId">
				</p-dropdown>
					<ng-container
						*ngIf="reasignarForm.get('usuarioId')?.invalid && reasignarForm.get('usuarioId')?.touched">
						<app-form-group-error-message [control]="reasignarForm.get('usuarioId')"></app-form-group-error-message>
					</ng-container>
				</div>
			</div>
			<ng-template pTemplate="footer">
				<div class="field col-12">
					<div class="flex justify-content-end">
						<button pButton type="submit" [label]="'form.button.guardar' | translate" icon="pi pi-save" iconPos="right"
							[disabled]="!ls.hasRole(role.GESTION_TRAMITE)"
							[pTooltip]="trans.requiereRolSeguridad" [tooltipDisabled]="ls.hasRole(role.GESTION_TRAMITE)" tooltipPosition="top"></button>
					</div>
				</div>
			</ng-template>
		</p-dialog>
	</form>
</section>
